export default {
  BET_PAYMENT: 'BET_PAYMENT',
  TOTAL_PAYMENT: 'TOTAL_PAYMENT',
  CANT_SPLIT: 'CANT_SPLIT',
  USER_BALANCE: 'USER_BALANCE',
  USER_LOGIN: 'USER_LOGIN',
  MAX_BET_COUNT: 'MAX_BET_COUNT',
  INVALID_BETS: 'INVALID_BETS',
};
